export default __webpack_public_path__ + "img/eaa3ea147cb3b5cad67a0e5a733aad12.gif";